import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useUpdateProject = () => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(async ({ projectId, projectData }) => {
    const newProject = await axios.post(`/projects/${projectId}`, projectData);
    return newProject;
  });

  const updateProject = (projectId, formData, { onSuccess }) => {
    mutate(
      { projectId, projectData: formData },
      {
        onSuccess: (res) => {
          queryClient.invalidateQueries('projects', { exact: true });
          toast.success(`The project ${res.data.name} is successfully updated`);
          onSuccess && onSuccess(res.data);
        },
        onError: (res) => {
          toast.error(res.message);
        },
      }
    );
  };

  return {
    updateProject,
    isLoading,
  };
};

export default useUpdateProject;
